import { useQueryUserLibraryCompletions } from '@ifit/gateway-wolf-athenaeum-service';
import { useRequiredRequestOptions } from '../query-options';

export const useCompletionsQuery = () => {
  const {
    headers,
    softwareNumber,
    useGatewayCache,
  } = useRequiredRequestOptions();
  return useQueryUserLibraryCompletions(
    { headers, softwareNumber, useGatewayCache },
    {},
  );
};
